"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputHovered = exports.inputFocused = exports.inputReadOnly = exports.inputDisabled = exports.inputStatus = exports.baseStyles = void 0;

var _stylitas = require("@creditas/stylitas");

var _consts = require("./consts");

const baseStyles = ({
  theme,
  width = '280px'
}) => (0, _stylitas.css)`
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 8px;
  cursor: text;
  width: ${width};
  border: ${_consts.DEFAULT_BORDER_SIZE}px solid
    ${_stylitas.utilities.palette.color(theme, 'neutral05')};
`;

exports.baseStyles = baseStyles;

const inputStatus = ({
  theme,
  variant
}) => variant !== 'default' && (0, _stylitas.css)`
    border: ${_consts.DEFAULT_BORDER_SIZE}px solid
      ${_stylitas.utilities.palette.color(theme, variant)};
  `;

exports.inputStatus = inputStatus;

const inputDisabled = ({
  theme,
  disabled
}) => disabled && (0, _stylitas.css)`
    border: ${_consts.DEFAULT_BORDER_SIZE}px solid
      ${_stylitas.utilities.palette.color(theme, 'neutral04')};
  `;

exports.inputDisabled = inputDisabled;

const inputReadOnly = ({
  theme,
  readOnly
}) => readOnly && (0, _stylitas.css)`
    border: ${_consts.DEFAULT_BORDER_SIZE}px solid
      ${_stylitas.utilities.palette.color(theme, 'neutral04')};
  `;

exports.inputReadOnly = inputReadOnly;

const inputFocused = ({
  theme,
  inputFocus,
  variant
}) => inputFocus && (0, _stylitas.css)`
    border: ${_consts.FOCUSED_BORDER_SIZE}px solid
      ${_stylitas.utilities.palette.color(theme, _consts.STYLE_VARIANTS.includes(variant) ? variant : 'secondary05')};
  `;

exports.inputFocused = inputFocused;

const inputHovered = ({
  theme,
  inputFocus,
  inputHover,
  variant,
  disabled,
  readOnly
}) => !inputFocus && !disabled && !readOnly && inputHover && variant === 'default' && (0, _stylitas.css)`
    border: ${_consts.DEFAULT_BORDER_SIZE}px solid
      ${_stylitas.utilities.palette.color(theme, 'neutral07')};
  `;

exports.inputHovered = inputHovered;